import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { DataWhatsAppMessageOtpRequest, DataWhatsAppMessageOtpResponse, SearchDataToken, Token } from '../interfaces/data-selects';
import {
  StepBienvenidaLtoV3Response,
  StepInicioCo,
  StepInitResponse,
  StepLoadDocumentSaveResponse,
  StepWelcome,
  StepWelcomeLto,
} from '../interfaces/step-data';
import { UpdateDataTokenCode } from '../class/update-data';

@Injectable({
  providedIn: 'root',
})
export class PostDataService {
  public search: any;

  constructor(private http: HttpClient) { }

  sendInitialIntent(type: 0 | 1): Observable<DataWhatsAppMessageOtpResponse> {
    const body = {
      type: type === 0 ? 'personalizada-form' : 'whatsapp-nip-form',
    }
    return this.http.post<DataWhatsAppMessageOtpResponse>(`${environment.apiUrlLtoV3}/countries/MX/forms`, body);
  }

  sendWhatsappCode(data: DataWhatsAppMessageOtpRequest): Observable<void> {
    return this.http.post<void>(`${environment.apiUrlLtoV3}/countries/MX/forms/send-otp`, data);
  }

  postRequestToken(email: string, body: SearchDataToken): Observable<Token> {
    return this.http.post<Token>(
      `${environment.apiUrlResume}/resume/${email}`,
      body
    );
  }
  postRequestTokenTruora(truoraToken: string | null): Observable<UpdateDataTokenCode> {
    return this.http.get<UpdateDataTokenCode>(
      `${environment.apiUrlResumeTruora}/resume/truora-token/${truoraToken!}`
    );
  }

  //SUBIR DOCUMENTOS MX
  postSaveDocument(
    countryCode: string,
    applicationId: string,
    type: string,
    file: any
  ): Observable<StepLoadDocumentSaveResponse> {
    return this.http.post<StepLoadDocumentSaveResponse>(
      `${environment.apiurl}/countries/${countryCode}/applications/${applicationId}/documents?type=${type}`,
      file
    );
  }
  //SUBIR DOCUMENTOS COL - MX
  postSaveDocumentCo(
    countryCode: string,
    applicationId: string,
    type: string,
    file: any
  ): Observable<StepLoadDocumentSaveResponse> {
    return this.http.post<StepLoadDocumentSaveResponse>(
      `${environment.apiUrlCo}/countries/${countryCode}/applications/${applicationId}/documents?type=${type}`,
      file
    );
  }

  /////GUARDAR STEP BIENVENIDA///
  postSaveDataWelcome(
    countryCode: string,
    stepWelcome: StepWelcome
  ): Observable<StepInitResponse> {
    return this.http.post<StepInitResponse>(
      `${environment.apiurl}/countries/${countryCode}/applications`,
      stepWelcome
    );
  }

  ///GUARDAR STEP INICIO COLOMBIA
  postSaveStepInitCo(
    countryCode: string,
    stepInit: StepInicioCo
  ): Observable<StepInitResponse> {
    return this.http.post<StepInitResponse>(
      `${environment.apiUrlCo}/countries/${countryCode}/applications`,
      stepInit
    );
  }

  //////NUEVO FLUJO LTO////
  /////GUARDAR STEP BIENVENIDA///
  postSaveDataWelcomeLto(
    countryCode: string,
    stepWelcomeLto: StepWelcomeLto
  ): Observable<StepInitResponse> {
    return this.http.post<StepInitResponse>(
      `${environment.apiUrlLto}/countries/${countryCode}/applications`,
      stepWelcomeLto
    );
  }

  //SUBIR DOCUMENTOS LTO
  postSaveDocumentLto(
    countryCode: string,
    applicationId: string,
    type: string,
    file: any,
    loadMethod?: string
  ): Observable<StepLoadDocumentSaveResponse> {
    return this.http.post<StepLoadDocumentSaveResponse>(
      `${environment.apiUrlLto}/countries/${countryCode}/applications/${applicationId}/documents?type=${type}${loadMethod ? '&loadMethod=' + loadMethod : ''}`,
      file
    );
  }

  //VERIFICACION CODIGO WHATSAPP
  postContactVerification(
    applicationId: string,
    token: string
  ): Observable<any> {
    return this.http.post<any>(
      `${environment.apiUrlVerification}/verification/api/v1.0/contact-verification/application/${applicationId}/token/${token}/phone`,
      null
    );
  }

  //VERIFICACION MAIL
  postMailVerification(applicationId: string, token: string): Observable<any> {
    return this.http.post<any>(
      `${environment.apiUrlVerification}/verification/api/v1.0/contact-verification/application/${applicationId}/token/${token}/mail`,
      null
    );
  }

  //////NUEVO FLUJO LTO V2////
  /////GUARDAR STEP BIENVENIDA///
  postSaveDataBienvenidaLto(countryCode: string, stepWelcomeLto: StepWelcomeLto): Observable<StepBienvenidaLtoV3Response> {
    return this.http.post<StepBienvenidaLtoV3Response>(
      `${environment.apiUrlLtoV3}/countries/${countryCode}/applications`,
      stepWelcomeLto
    );
  }

  sendDuplicatedPhoneOrEmailTeamsNotification(countryCode: string, stepWelcomeLto: StepWelcomeLto, names: { platformName: string, workCityName: string, whereFindOutName: string }): Observable<void> {
    const body = {
      email: stepWelcomeLto.email,
      cellphoneFullNumber: `${stepWelcomeLto.cellPhoneCountryCode}${stepWelcomeLto.mobilePhoneNumber}`,
      fullName: `${stepWelcomeLto.firstName} ${stepWelcomeLto.lastName} ${stepWelcomeLto.secondLastName ?? ''}`.trim(),
      platformName: names.platformName,
      workCityName: names.workCityName,
      whereFindOutName: names.whereFindOutName
    };
    return this.http.post<void>(`${environment.apiUrlLtoV3}/countries/${countryCode}/applications/notification/teams`, body);
  }
}
